module.exports = __webpack_public_path__ + "569d6598043242a9a6b1d4d0a0b60003.jpg";